import { Component, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CuttingClient } from 'cloud-shared-lib';
import { ProfileService } from './profile.service';

@Component({
  selector: 'fuse-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class FuseProfileComponent {
  get client(): CuttingClient {
    return this.profileService.about;
  }

  constructor(private profileService: ProfileService) {}
}
